import api from "./api";

export const getPaymentBalance = async (params) => {
  return api
    .get({
      endpoint: "/x/balance",
      port: process.env.REACT_APP_PORT_PAYMENT,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
